import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TierDetailSettings } from '@aptitude/shared-vanilla';

import { Tier } from '../../../../../types/rfp/offer';

@Component({
    selector: 'app-tier-selection-modal',
    templateUrl: './tier-selection-modal.component.html',
    standalone: false
})
export class TierSelectionModalComponent {
  @Input() offerName = 'Offer Name';
  @Input() tiers: Array<Tier> = [];
  @Input() tierSelected = 1;
  @Input() displayOptimized = false;
  @Input() canChangeTier = true;
  @Input() displayAttainability = true;
  @Input() tierDetailSettings: TierDetailSettings = {} as TierDetailSettings;

  constructor(public activeModal: NgbActiveModal) {}
}
